__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@aviv-unified-frontend/branded-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aviv-csnt/react", "3.1.0", () => (() => (__webpack_require__(6828))), 1);
			register("@aviv-dxp/react-thor", "2.25.1", () => (() => (__webpack_require__(8135))), 1);
			register("@aviv-trak/feature-flagging", "1.2.0", () => (() => (__webpack_require__(440))), 1);
			register("@aviv-unified-frontend/runtime/authentication", "9.4.0", () => (() => (__webpack_require__(8698))), 1);
			register("@aviv-unified-frontend/runtime/brand", "9.4.0", () => (() => (__webpack_require__(339))), 1);
			register("@aviv-unified-frontend/runtime/environment", "9.4.0", () => (() => (__webpack_require__(7403))), 1);
			register("@aviv-unified-frontend/runtime/fetcher", "9.4.0", () => (() => (__webpack_require__(1965))), 1);
			register("@aviv-unified-frontend/runtime/head", "9.4.0", () => (() => (__webpack_require__(8428))), 1);
			register("@aviv-unified-frontend/runtime/i18n", "9.4.0", () => (() => (__webpack_require__(2542))), 1);
			register("@aviv-unified-frontend/runtime/lifecycle", "9.4.0", () => (() => (__webpack_require__(400))), 1);
			register("@aviv-unified-frontend/runtime/monitoring", "9.4.0", () => (() => (__webpack_require__(9568))), 1);
			register("@aviv-unified-frontend/runtime/router", "9.4.0", () => (() => (__webpack_require__(2965))), 1);
			register("@aviv-web-core/tracking", "1.1.0", () => (() => (__webpack_require__(4357))), 1);
			register("@gemini/core", "3.0.0", () => (() => (__webpack_require__(8546))), 1);
			register("@react-aria/focus", "3.21.2", () => (() => (__webpack_require__(1433))), 1);
			register("@react-aria/i18n", "3.12.13", () => (() => (__webpack_require__(4778))), 1);
			register("@react-aria/interactions", "3.25.6", () => (() => (__webpack_require__(8179))), 1);
			register("@react-aria/overlays", "3.30.0", () => (() => (__webpack_require__(626))), 1);
			register("@react-aria/ssr", "3.9.10", () => (() => (__webpack_require__(1557))), 1);
			register("@react-aria/toast", "3.0.8", () => (() => (__webpack_require__(9423))), 1);
			register("@react-aria/utils", "3.31.0", () => (() => (__webpack_require__(3293))), 1);
			register("@react-stately/overlays", "3.6.20", () => (() => (__webpack_require__(755))), 1);
			register("@react-stately/toast", "3.1.2", () => (() => (__webpack_require__(8683))), 1);
			register("react-dom/client", "19.2.3", () => (() => (__webpack_require__(9800))), 1);
			register("react-dom/server", "19.2.3", () => (() => (__webpack_require__(6530))), 1);
			register("react-dom", "19.2.3", () => (() => (__webpack_require__(3007))), 1);
			register("react/jsx-runtime", "19.2.3", () => (() => (__webpack_require__(7900))), 1);
			register("react", "19.2.3", () => (() => (__webpack_require__(2128))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};